import api from './api';

const shippingRatesService = {
  // Récupérer tous les tarifs
  getAll: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    return api.get(`/api/admin/shipping-rates?${params}`);
  },

  // Récupérer un tarif par ID
  getById: async (id) => {
    return api.get(`/api/admin/shipping-rates/${id}`);
  },

  // Créer un nouveau tarif
  create: async (data) => {
    return api.post('/api/admin/shipping-rates', data);
  },

  // Mettre à jour un tarif
  update: async (id, data) => {
    return api.put(`/api/admin/shipping-rates/${id}`, data);
  },

  // Supprimer un tarif
  delete: async (id) => {
    return api.delete(`/api/admin/shipping-rates/${id}`);
  },

  // Activer/désactiver un tarif
  toggleActive: async (id) => {
    return api.patch(`/api/admin/shipping-rates/${id}/toggle`);
  },

  // Obtenir les zones disponibles
  getZones: async () => {
    return api.get('/api/admin/shipping-rates/zones');
  },

  // Obtenir les transporteurs disponibles
  getCarriers: async () => {
    return api.get('/api/admin/shipping-rates/carriers');
  },
};

export default shippingRatesService;

